import { render, staticRenderFns } from "./TransferChart.vue?vue&type=template&id=408cc422"
import script from "./TransferChart.vue?vue&type=script&lang=js"
export * from "./TransferChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports